import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppState {
  drawerOpen: boolean;
  company: "ecco" | "e-cube";

  wssUrl: string | null;
  pushClientUrl: string | null;
}

// Define the initial state using that type
const initialState: AppState = {
  drawerOpen: false,
  company: "e-cube",

  wssUrl: null,
  pushClientUrl: null,
};

export const appSlice = createSlice({
  name: "app",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    toggleDrawer: (state: any) => {
      state.drawerOpen = !state.drawerOpen;
    },
    setCompany: (state: any, action: PayloadAction<"ecco" | "e-cube">) => {
      state.company = action.payload;
    },

    setWssUrl: (state: any, action: PayloadAction<string>) => {
      state.wssUrl = action.payload;
    },
    setPushClientUrl: (state: any, action: PayloadAction<string>) => {
      state.pushClientUrl = action.payload;
    },
  },
});

export const {
  toggleDrawer,
  setCompany,

  setWssUrl,
  setPushClientUrl,
} = appSlice.actions;

// Other code such as selectors can use the imported `RootState` type
// export const selectIsLoggedIn = (state: RootState) => state.user.isLoggedIn

export default appSlice.reducer;
